// Internet Explorer 11 requires polyfills and partially supported by this project.
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import 'typeface-poppins';
import './i18n';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import App from 'app/App';
import { Amplify } from 'aws-amplify';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import awsconfig from './awsConfig';
import aws_auth from 'aws-auth';
import { createRoot } from 'react-dom/client';
import './sentry';
// SEE-1410: Amplitude disabled — init() never runs, so all call sites become
// no-ops (SDK queues pre-init calls). Uncomment to re-enable.
// import './amplitude';
// SEE-1170: register the Hub listener that catches the "not provisioned" SSO
// failure before Amplify processes the OAuth callback at boot.
import 'app/auth/ssoErrorSignal';

const aws_config_new = {
  ...awsconfig,
  ...aws_auth,
};

// NOTE (mobile SSO contract): the native app (speedchain-mobile
// providers/auth/ssoAuthSession.ts) writes the session back into this WebView
// using Amplify v4's localStorage keys
// (CognitoIdentityServiceProvider.<clientId>.{idToken,accessToken,refreshToken,clockDrift}).
// A major aws-amplify upgrade here changes that storage schema and will
// silently break mobile SSO. Coordinate any such bump with the mobile repo.
Amplify.configure(aws_config_new);

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}

reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
